import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';

import {Loader, Menu, Sidebar} from 'semantic-ui-react';

import {subredditsList} from '../actions';

class RedditSidebar extends Component {
    componentDidMount() {
        this
            .props
            .subredditsList('/default');
    }

    componentWillReceiveProps({after}) {
        if (after) {
            this
                .props
                .subredditsList('/default', {after});
        }
    }

    shouldComponentUpdate({loading, location: {
            pathname
        }, visible}) {
        return loading !== this.props.loading || pathname !== this.props.location.pathname || visible !== this.props.visible;
    }

    render() {
        const {items, loading, route, visible} = this.props;
        return <Sidebar as={Menu} vertical={true} inverted={true} animation='overlay' visible={visible}>
            {
                items.map(
                    ({data}) => <Menu.Item
                        as={NavLink}
                        content={data.display_name}
                        exact={true}
                        key={data.id}
                        name={data.title}
                        to={route + data.url}/>
                )
            }
            {
                loading
                    ? <Menu.Item key="Menu-loader">
                            <Loader active={true} inline="centered"/>
                        </Menu.Item>
                    : null
            }
        </Sidebar>;
    }
}

const connectedSidebar = connect(({routes: {
        clientReddit
    }, clientReddit: {
        subreddits
    }}) => ({
    route: clientReddit,
    ...subreddits
}), {subredditsList})(RedditSidebar);
export default withRouter(connectedSidebar);


// WEBPACK FOOTER //
// ./src/apps/client-reddit/components/Sidebar.js